export default "__VITE_ASSET__a7efefc8__"